import { IConfiguration } from "@/interfaces";

export const TokenIAuthenticationService = "IAuthenticationService";

export interface IAuthenticationService {
  GetAccessTokenFromAAD(configuration: IConfiguration): Promise<boolean>;
  GetUserIdentityToken(): Promise<string | undefined>;
  GetCallbackToken(): Promise<string>;
  GetTokenFromAAD(): Promise<string>;
}
